import React, { Component } from "react";
import { message, Table, Empty, Alert, Row, Col, Select } from "antd";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { ModalItem, ButtonItem, InputNumberItem, DatePickerItem, InputItem, MensajeError } from "../../../../Components/Items";
import SelectProyectosItem from "../../../../Components/SelectProyectosItem";

const { Option } = Select;

class ModalOrdenRetrabajoPU extends Component {
  state = {
    loading: false,
    guardando: false,
    grupos: [],
    insumoRetrabajoId: undefined,
    piezas: {},
    fechaInicio: moment().startOf("hour").add(1, "hour"),
    proyectoEjecucionId: undefined,
    proyectoOrigenId: undefined,
    descripcion: "",
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      this.setState({
        grupos: [],
        insumoRetrabajoId: undefined,
        piezas: {},
        fechaInicio: moment().startOf("hour").add(1, "hour"),
        proyectoEjecucionId: undefined,
        proyectoOrigenId: undefined,
        descripcion: "",
      });
      this.cargar();
    }
  }

  cargar = () => {
    this.setState({ loading: true });
    axios
      .post("ordenesDeProduccionPU/piezasEnRetrabajo", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          const grupos = res.data.grupos || [];
          this.setState({ grupos, insumoRetrabajoId: grupos.length === 1 ? grupos[0].insumoRetrabajoId : undefined }, this.sugerirProyectos);
        } else {
          MensajeError({ message: res.data.error || "No se pudieron consultar las piezas en retrabajo" });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  grupoActual = () => this.state.grupos.find((g) => g.insumoRetrabajoId === this.state.insumoRetrabajoId);

  sugerirProyectos = () => {
    const primero = this.grupoActual()?.renglones?.[0];
    if (primero) {
      this.setState({
        proyectoEjecucionId: this.state.proyectoEjecucionId || primero.proyectoEjecucionId,
        proyectoOrigenId: this.state.proyectoOrigenId || primero.proyectoOrigenId,
      });
    }
  };

  cambiarInsumo = (insumoRetrabajoId) => this.setState({ insumoRetrabajoId, piezas: {} }, this.sugerirProyectos);

  clave = (renglon) => `${renglon.ordenId}|${renglon.etapaId}`;

  totalPiezas = () => Object.values(this.state.piezas).reduce((acc, v) => acc + (Number(v) || 0), 0);

  crear = () => {
    const grupo = this.grupoActual();
    const selecciones = (grupo?.renglones || [])
      .filter((r) => this.state.piezas[this.clave(r)] > 0)
      .map((r) => ({ ordenId: r.ordenId, etapaId: r.etapaId, piezas: this.state.piezas[this.clave(r)] }));
    if (selecciones.length === 0) {
      MensajeError({ message: "Elige cuántas piezas de cada orden se mandan a retrabajo" });
      return;
    }
    if (!this.state.proyectoEjecucionId || !this.state.proyectoOrigenId) {
      MensajeError({ message: "Elige el proyecto de producción y el proyecto general" });
      return;
    }

    this.setState({ guardando: true });
    axios
      .post(
        "ordenesDeProduccionPU/agregarOrdenRetrabajo",
        {
          empresaId: this.props.empresaId,
          usuarioId: this.props.usuarioId,
          insumoRetrabajoId: this.state.insumoRetrabajoId,
          selecciones,
          fechaInicio: this.state.fechaInicio,
          proyectoEjecucionId: this.state.proyectoEjecucionId,
          proyectoOrigenId: this.state.proyectoOrigenId,
          descripcion: this.state.descripcion,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ guardando: false });
        if (res.data.success === 2) {
          message.success(res.data.mensaje || "Orden de retrabajo creada");
          this.props.onCreada && this.props.onCreada(res.data.orden);
        } else {
          MensajeError({ message: res.data.error || "No se pudo crear la orden de retrabajo" });
        }
      })
      .catch(() => {
        this.setState({ guardando: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  render() {
    const { grupos, insumoRetrabajoId, piezas } = this.state;
    const grupo = this.grupoActual();

    return (
      <ModalItem
        title="Orden de retrabajo"
        visible={this.props.visible}
        spinning={this.state.loading || this.state.guardando}
        onCancel={this.props.onCerrar}
        width="75%"
        paddingTop
      >
        {grupos.length === 0 && !this.state.loading ? (
          <Empty description="No hay piezas en etapas de retrabajo para trabajar" />
        ) : (
          <>
            <Alert
              type="info"
              showIcon
              style={{ marginBottom: 12 }}
              message="Junta piezas de varias órdenes que están en una etapa de retrabajo para producirlas en una orden nueva del insumo de retrabajo. Las órdenes de origen dejan de contarlas como pendientes."
            />
            <Row gutter={[16, 12]} style={{ marginBottom: 12 }}>
              <Col span={24}>
                <div style={{ fontWeight: 600, marginBottom: 4 }}>Insumo de retrabajo</div>
                <Select style={{ width: "100%" }} value={insumoRetrabajoId} onChange={this.cambiarInsumo} placeholder="Elige el insumo">
                  {grupos.map((g) => (
                    <Option key={g.insumoRetrabajoId} value={g.insumoRetrabajoId}>
                      {g.clave ? `${g.clave} - ` : ""}
                      {g.descripcion}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>

            {grupo && (
              <>
                <Table
                  size="small"
                  pagination={false}
                  rowKey={(r) => this.clave(r)}
                  dataSource={grupo.renglones}
                  columns={[
                    { title: "Orden", dataIndex: "folio", key: "folio", width: 140 },
                    { title: "Etapa", dataIndex: "etapaNombre", key: "etapaNombre" },
                    { title: "Piezas disponibles", dataIndex: "piezas", key: "piezas", align: "right", width: 150 },
                    {
                      title: "Piezas a retrabajar",
                      key: "tomar",
                      width: 180,
                      render: (_, renglon) => (
                        <InputNumberItem
                          min={0}
                          max={renglon.piezas}
                          style={{ width: "100%" }}
                          value={piezas[this.clave(renglon)]}
                          onChange={(valor) => this.setState((prev) => ({ piezas: { ...prev.piezas, [this.clave(renglon)]: valor } }))}
                        />
                      ),
                    },
                  ]}
                />
                <div style={{ textAlign: "right", margin: "8px 0 12px", fontWeight: 600 }}>Total: {this.totalPiezas()} pzs</div>

                <Row gutter={16}>
                  <Col span={8}>
                    <div style={{ fontWeight: 600, marginBottom: 4 }}>Fecha y hora programada</div>
                    <DatePickerItem
                      style={{ width: "100%" }}
                      allowClear={false}
                      showTime={{ format: "HH:mm", minuteStep: 5 }}
                      format="DD/MM/YYYY HH:mm"
                      value={this.state.fechaInicio}
                      onChange={(fechaInicio) => this.setState({ fechaInicio })}
                    />
                  </Col>
                  <Col span={8}>
                    <div style={{ fontWeight: 600, marginBottom: 4 }}>Proyecto Producción</div>
                    <SelectProyectosItem
                      empresaId={this.props.empresaId}
                      headersToken={this.props.headersToken}
                      value={this.state.proyectoEjecucionId}
                      onChange={(proyectoEjecucionId) => this.setState({ proyectoEjecucionId })}
                    />
                  </Col>
                  <Col span={8}>
                    <div style={{ fontWeight: 600, marginBottom: 4 }}>Proyecto General</div>
                    <SelectProyectosItem
                      empresaId={this.props.empresaId}
                      headersToken={this.props.headersToken}
                      value={this.state.proyectoOrigenId}
                      onChange={(proyectoOrigenId) => this.setState({ proyectoOrigenId })}
                    />
                  </Col>
                  <Col span={24} style={{ marginTop: 12 }}>
                    <div style={{ fontWeight: 600, marginBottom: 4 }}>Descripción</div>
                    <InputItem value={this.state.descripcion} onChange={(e) => this.setState({ descripcion: e.target.value })} placeholder="Opcional" />
                  </Col>
                </Row>
              </>
            )}

            <ButtonItem type="primary" onClick={this.crear} disabled={!grupo} style={{ display: "block", margin: "16px 0 0 auto" }}>
              Crear orden de retrabajo
            </ButtonItem>
          </>
        )}
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  usuarioId: state.user.usuarioId,
});

export default connect(mapStateToProps)(ModalOrdenRetrabajoPU);
